// extracted by css-extract-rspack-plugin
module.exports =  {"cardListWrapper":"VfuZk","brdr_skip":"CC791","loadMore":"BWKk2","loaderSpacing":"u4lSG"};